import Component, { subscribe } from "../../js/lib/component";
import Page from "../page/page"

const classList = {
  root: ".js-menu",
  toggle: ".js-menu-toggle",
  list: ".js-menu-list",
  trigger: ".js-menu-trigger",
  dropmenu: ".js-menu-dropmenu"
};

export default class Menu extends Component {
  init() {
    this.openText = this.$.toggle.text();
    this.closeText = "Закрыть";
  }
  events() {
    this.$.toggle.on("click", () => this.toggleMenu());
    this.$.trigger.on("click", e => this.toggleSubMenu(e));
    this.$.document.on("click", e => this.closeMenu(e));
    subscribe("page:esc", () => this.closeMenu());
  }
  toggleMenu() {
    this[this.get("opened") ? "closeMenu" : "openMenu"].call(this);
  }
  closeMenu(e) {
    if (e) {
      const $target = $(e.target);

      const isRoot = $target.is(classList.root);
      const isChilds = $target.closest(classList.root).length > 0;

      if (isRoot || isChilds) return;
    }

    this.$.toggle.text(this.openText);
    this.$.list.hide();
    this.$.root.removeClass("is-open");
    this.set({ opened: false });
  }
  openMenu() {
    this.$.toggle.text(this.closeText);
    this.$.list.show();
    this.$.root.addClass("is-open");
    this.set({ opened: true });
  }
  toggleSubMenu(e) {
    if (this.$.window.width() > Page.breakpoint.l) return;
    
    e.preventDefault();

    const $trigger = $(e.currentTarget);
    const $submenu = $trigger.siblings(this.$.dropmenu);

    $trigger.parent().toggleClass("is-open");
    $submenu.toggle();
  }
}

Component.mount(Menu, {
  name: "Menu",
  classList,
  state: {
    opened: false
  }
});
